import React from "react"
import { formatText } from "../../../v1/helpers/stringHelpers"
import StarIcon from "../../../images/star_icon.svg"
import ReactSVG from "react-svg"
import { Button, Image } from "semantic-ui-react"
import WalkInLogo from "../../../images/walk-in.svg"
import AppointmentOnlyLogo from "../../../images/appointment-only.svg"
import CaLogo from "../../../images/caradvise_icon.svg"
import { useTranslation } from "react-i18next"
import EmptyShopLogo from "../../../images/empty_shop_logo.svg"
import { MD_HD_VEHICLE_TYPE_ID } from "../../../v1/constants/application"
import { getNewTiresServiceFromServices } from "../../../v1/helpers/orderServiceHelpers"
import { getActiveVehicle } from "../../../v1/helpers/vehicleHelpers"
import { connect } from "react-redux"
import { numberFormatToCurrency } from "../../../shared_component/utils/currency"
import { PricedAtShop } from "./PricedAtShop"

const SelectShops = ({ shop, user, cart, selectedShop, handleShopSelection, isSubmitting }) => {
  const { t } = useTranslation("affiliationShopSelection")

  const showPrices = () => {
    if (shop.price_estimates && shop.price_estimates.length > 0) {
      const index = shop.price_estimates.findIndex(
        (e) => e.shop_price_estimate == null || e.shop_price_estimate == ""
      )
      if (index > -1) {
        return false
      } else {
        return true
      }
    }
  }

  let vehicleTypeId
  if (user) {
    const activeVehicle = getActiveVehicle()
    vehicleTypeId = (activeVehicle && activeVehicle.vehicle_type_id) || null
  }

  const retailPrice = () => {
    if (shop.price_estimates && shop.price_estimates.length > 0) {
      const index = shop.price_estimates.findIndex(
        (e) => e.shop_price_estimate == null || e.shop_price_estimate == ""
      )
      if (index > -1) {
        return false
      } else {
        let price = 0
        shop.price_estimates.forEach((e) => {
          price = price + Number(e.shop_price_estimate)
        })
        return numberFormatToCurrency((price + shop.total_retail_savings).toString())
      }
    }
  }

  const shopDisplayPrice = () => {
    if (shop.price_estimates && shop.price_estimates.length > 0) {
      const index = shop.price_estimates.findIndex(
        (e) => e.shop_price_estimate == null || e.shop_price_estimate == ""
      )
      if (index > -1) {
        return t("common:priceAtShopLbl")
      } else {
        let price = 0
        shop.price_estimates.forEach((e) => {
          price = price + Number(e.shop_price_estimate)
        })
        return numberFormatToCurrency(price.toString())
      }
    }
  }

  const isSelectedShop = selectedShop?.id === shop?.id

  return (
    <div className={`instacart-shops ${isSelectedShop ? "selected-shop-border" : ""}`}>
      <div className="shop-rating-users">
        <div className="shop-rating-box shop-rating-star">
          <ReactSVG src={StarIcon} />
          <p className="shop-rating">
            {shop?.average_rating || "--"} {shop.rating ? `(${shop.rating})` : ""}
          </p>
        </div>
        <div className="shop-rating-box walk-in-only-bg">
          <p className="shop-caradvisors">
            {formatText(
              t("carAdvisors", {
                CAR_ADVISORS: shop.completed_shop_orders_count || "--"
              }),
              "shop-caradvisors-span"
            )}
          </p>
        </div>
        <div className="shop-rating-box walk-in-only-bg">
          <p className="walk-in-only">
            {t(shop?.company?.walk_ins_only ? "walkInOnly" : "appointmentOnly")}
          </p>
        </div>
      </div>
      <div className="shop-details">
        <Image className="shop-logo" src={shop.logo_url ? shop.logo_url : EmptyShopLogo} />
        <div className="shop-info">
          <p className="shop-name">{shop.name}</p>
          <p className="shop-address">
            {formatText(
              t("shopInfo", {
                ADDRESS: `${shop.address_line1}, ${shop.city}, ${shop.state} ${shop.zip}`,
                MILES: shop.distance_config.display_value_abbr
              }),
              "shop-address-span"
            )}
          </p>
        </div>

        {/* Shop Price Details */}
        <div className="shop-price-details">
          {shop.company.pricing_disabled &&
          !shop.cdk_dealer &&
          vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID ? (
            <div />
          ) : !shop.company.pricing_disabled &&
            !shop.cdk_dealer &&
            vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID &&
            shop.price_estimates &&
            shop.price_estimates.length > 0 ? (
            !showPrices() ? (
              <PricedAtShop fontSize={14} />
            ) : (
              <div />
            )
          ) : (
            <PricedAtShop fontSize={14} />
          )}
          {shop.company.pricing_disabled &&
          !shop.cdk_dealer &&
          vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID ? (
            <PricedAtShop fontSize={14} />
          ) : showPrices() &&
            !shop.company.pricing_disabled &&
            !shop.cdk_dealer &&
            vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID &&
            shop.price_estimates &&
            shop.price_estimates.length > 0 ? (
            <div className="shopPriceContainer">
              {shop && shop.total_retail_savings > 0 && (
                <p className="discount-price">{shopDisplayPrice()}</p>
              )}
              <p className="original-price">{retailPrice()}</p>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
      <Button
        onClick={() => handleShopSelection(shop)}
        className={isSelectedShop ? "instacart-shop-selected" : "instacart-shop-select"}
      >
        {t("selectShop")}
      </Button>
    </div>
  )
}

const mapStateToProps = (state) => {
  const user = state.user
  const cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)

  return {
    user: state.user,
    cart: cart
  }
}

export default connect(mapStateToProps)(SelectShops)
